import { Directive, HostListener } from '@angular/core';
import { NgControl } from '@angular/forms';

@Directive({
  selector: '[appResetDateSpecialValues]'
})
export class ResetDateSpecialValuesDirective {

  constructor(private ngControl: NgControl) { }

  @HostListener('input', ['$event.target.value'])
  onInput(value: string) {
    for (const specialValue of dateSpecialValues) {
      if (value === specialValue.originalValue) {
        const control = this.ngControl.control;
        if (control) {
          control.setValue(specialValue.transformedValue);
        }
        return;
      }
    }
  }
}

export const dateSpecialValues: Array<{originalValue: string, transformedValue: string}> = [
  {originalValue: "00000000", transformedValue: "00.00.2000"},
  {originalValue: "00.00.0000", transformedValue: "00.00.2000"}
];
